<template>
	<div class="pagesContent">
		<el-container>
			<el-header height="120px">
				<el-card>
					<el-row class="header-title">
						<el-col :span="15">
							<h4><i class="el-icon-notebook-2"></i> 员工列表</h4>
						</el-col>
						<el-col :span="5">
							<el-select v-model="SearchFlag" @change="getStaffList()" placeholder="请选择员工状态"
								size="medium">
								<el-option label="全部" :value="0"></el-option>
								<el-option label="在职" :value="1"></el-option>
								<el-option label="离职" :value="2"></el-option>
							</el-select>
						</el-col>
						<el-col :span="4">
							<el-button type="primary" size="medium" @click="dialogFormVisibleAdd = true">添加</el-button>
							<el-button type="primary" size="medium" icon="el-icon-plus" @click="toAddbatch">批量添加
							</el-button>
						</el-col>
					</el-row>
				</el-card>
			</el-header>
			<el-main class="main-box">
				<el-card>
					<el-table style="width: 100%;" :data="staffList" highlight-current-row stripe>
						<el-table-column type="index" label="编号" align="center" width="80"></el-table-column>
						<el-table-column prop="JobNumber" label="工号" align="center"></el-table-column>
						<el-table-column prop="Name" label="姓名" align="center"></el-table-column>
						<el-table-column prop="Sex" label="性别" align="center">
							<template slot-scope="scope">
								<span v-if="scope.row.Sex == 1">男</span>
								<span v-else-if="scope.row.Sex == 2">女</span>
								<span v-else>未知</span>
							</template>
						</el-table-column>
						<el-table-column prop="CreateTime" label="创建时间" align="center" sortable>
							<template slot-scope="scope">
								{{scope.row.CreateTime | dateYMDFormat}}
							</template>
						</el-table-column>
						<el-table-column prop="Flag" label="状态" header-align="center" align="center">
							<template slot-scope="scope">
								<span v-if="scope.row.Flag == 0">未知</span>
								<span v-else-if="scope.row.Flag == 1">在职</span>
								<span v-else-if="scope.row.Flag == 2">离职</span>
								<span v-else-if="scope.row.Flag == 3">删除</span>
							</template>
						</el-table-column>
						<el-table-column prop="Flag" label="所属角色" header-align="center" align="center">
							<template slot-scope="{row}">
								<el-select v-model="row.roles" multiple placeholder="请选择" @change="setRole(row)" @remove-tag='delRole($event,row)'>
								    <el-option v-for="item in roles" :key="item.Id" :label="item.Name" :value="item.Id" @click="ccccc(item)">
								    </el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column label="操作" align="center">
							<template slot-scope="scope">
								<el-row :gutter="20">
									<el-col :span="12">
										<el-button size="mini" type="primary" @click="handleAuditStaff(scope.$index, scope.row)">编辑</el-button>
									</el-col>
									<el-col :span="12">
										<span v-if="scope.row.PasswordErrorCount < 3">
											<el-button size="mini" type="danger" plain disabled>解锁</el-button>
										</span>
										<span v-else>
											<el-button size="mini" type="danger"
												@click="handleUnlockingStaff(scope.$index, scope.row)">解锁</el-button>
										</span>
									</el-col>
								</el-row>
							</template>
						</el-table-column>
					</el-table>
				</el-card>
			</el-main>

			<!-- 更改 员工信息表单 -->
			<el-dialog title="更改员工信息" :visible.sync="dialogFormVisibleUpdate" width="40%">
				<div class="dialog-body">
					<el-form :model="staffInfo" label-position="right" label-width="100px" autocomplete="off"
						ref="staffInfo">
						<el-form-item label="员工姓名" size="small">
							<el-col :span="14">
								<el-input v-model="staffInfo.Name" placeholder="请输入员工姓名"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="员工性别" size="small">
							<el-radio-group v-model="staffInfo.Sex">
								<el-radio :label="1">男</el-radio>
								<el-radio :label="2">女</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="联系电话" size="small">
							<el-col :span="14">
								<el-input v-model="staffInfo.Phone" placeholder="请输入员工联系电话" maxlength="11"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="身份证号码" size="small">
							<el-col :span="14">
								<el-input v-model="staffInfo.IDNumber" placeholder="请输入员工身份证号码" maxlength="18">
								</el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="籍贯" size="small">
							<el-col :span="14">
								<el-input v-model="staffInfo.NativePlace" placeholder="请输入员工籍贯"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="现居住地" size="small">
							<el-col :span="14">
								<el-input v-model="staffInfo.CurrentResidence" placeholder="请输入员工现居住地"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="毕业院校" size="small">
							<el-col :span="14">
								<el-input v-model="staffInfo.AlmaMater" placeholder="请输入员工毕业院校"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="学历" size="small">
							<el-col :span="14">
								<el-input v-model="staffInfo.Degree" placeholder="请输入员工学历"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="专业" size="small">
							<el-col :span="14">
								<el-input v-model="staffInfo.Specialty" placeholder="请输入员工专业"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="登录账号" size="small">
							<el-col :span="14">
								<el-input v-model="staffInfo.UserName" placeholder="请输入员工登录账号"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="登录密码" size="small">
							<el-col :span="14">
								<el-input v-model="staffInfo.Password" placeholder="请输入登录密码"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="员工状态" size="small">
							<el-select v-model="staffInfo.Flag" placeholder="请选择员工状态" @change="changeFlag">
								<el-option label="在职" :value="1"></el-option>
								<el-option label="离职" :value="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="入职时间" size="small">
							<el-col :span="14">
								<!-- value-format="yyyy-MM-dd" -->
								<el-date-picker type="date" v-model="staffInfo.JoinTime" value-format="yyyy-MM-dd"
									placeholder="请选择员工入职时间" size="small"></el-date-picker>
							</el-col>
						</el-form-item>
						<!-- 当状态为离职时，显示此选项 -->
						<el-form-item label="离职时间" size="small" v-if="staffInfo.Flag == 2">
							<el-col :span="14">
								<el-date-picker type="date" v-model="staffInfo.QuitTime" value-format="yyyy-MM-dd"
									placeholder="请选择员工离职时间" size="small"></el-date-picker>
							</el-col>
						</el-form-item>
					</el-form>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogFormVisibleUpdate = false">取 消</el-button>
					<el-button type="primary" @click="submitUpdate('staffInfo')">确 定</el-button>
				</div>
			</el-dialog>
			<!-- 单个添加 员工信息表单 -->
			<el-dialog title="添加员工" :visible.sync="dialogFormVisibleAdd" width="40%" @close="onCloseAdd">
				<div class="dialog-body">
					<el-form :model="addInfo" label-position="right" label-width="100px" autocomplete="off"
						ref="addInfo" :rules="AddRules">
						<el-form-item label="员工工号" prop="JobNumber" size="small">
							<el-col :span="14">
								<el-input v-model="addInfo.JobNumber" placeholder="请输入员工工号"
									@input="judgeStaffJobNumber()"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="员工姓名" size="small" prop="Name">
							<el-col :span="14">
								<el-input v-model="addInfo.Name" placeholder="请输入员工姓名"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="员工性别" size="small" prop="Sex">
							<el-radio-group v-model="addInfo.Sex">
								<el-radio :label="1">男</el-radio>
								<el-radio :label="2">女</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="联系电话" size="small" prop="Phone">
							<el-col :span="14">
								<el-input v-model="addInfo.Phone" placeholder="请输入员工联系电话" maxlength="11"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="身份证号码" size="small" prop="IDNumber">
							<el-col :span="14">
								<el-input v-model="addInfo.IDNumber" placeholder="请输入员工身份证号码" maxlength="18"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="籍贯" size="small" prop="NativePlace">
							<el-col :span="14">
								<el-input v-model="addInfo.NativePlace" placeholder="请输入员工籍贯"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="现居住地" size="small" prop="CurrentResidence">
							<el-col :span="14">
								<el-input v-model="addInfo.CurrentResidence" placeholder="请输入员工现居住地"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="毕业院校" size="small" prop="AlmaMater">
							<el-col :span="14">
								<el-input v-model="addInfo.AlmaMater" placeholder="请输入员工毕业院校"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="学历" size="small" prop="Degree">
							<el-col :span="14">
								<el-input v-model="addInfo.Degree" placeholder="请输入员工学历"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="专业" size="small" prop="Specialty">
							<el-col :span="14">
								<el-input v-model="addInfo.Specialty" placeholder="请输入员工专业"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="登录账号" size="small" prop="UserName">
							<el-col :span="14">
								<el-input v-model="addInfo.UserName" placeholder="请输入员工登录账号"
									@input="judgeStaffUserName()"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="登录密码" size="small" prop="Password">
							<el-col :span="14">
								<el-input v-model="addInfo.Password" placeholder="请输入系统登录密码"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="员工状态" size="small" prop="Flag">
							<el-select v-model="addInfo.Flag" placeholder="请选择员工状态" size="small" @change="changeFlag">
								<el-option label="在职" :value="1"></el-option>
								<el-option label="离职" :value="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="入职时间" size="small" prop="JoinTime">
							<el-col :span="14">
								<el-date-picker type="date" v-model="addInfo.JoinTime" value-format="yyyy-MM-dd"
									placeholder="请选择员工入职时间" size="small"></el-date-picker>
							</el-col>
						</el-form-item>
						<!-- 当状态为离职时，显示此选项 -->
						<el-form-item label="离职时间" size="small" prop="QuitTime" v-if="addInfo.Flag == 2">
							<el-col :span="14">
								<el-date-picker type="date" v-model="addInfo.QuitTime" value-format="yyyy-MM-dd"
									placeholder="请选择员工离职时间" size="small"></el-date-picker>
							</el-col>
						</el-form-item>
					</el-form>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogFormVisibleAdd = false">取 消</el-button>
					<el-button type="primary" @click="submitAdd('addInfo')">确 定</el-button>
				</div>
			</el-dialog>
		</el-container>
	</div>
</template>

<script>
	import rsa from '/src/utils/rsa.js'
	export default {
		//需要刷新的页面内注入
		inject: ['reload'],
		data() {
			//表单 自定义规则
			//员工工号是否存在
			var validateJobNumber = (rule, value, callback) => {
				if (this.existenceJobNumber) { //不通过
					callback(new Error('该工号已存在,请重新输入！'))
				} else { //通过
					callback()
				}
			}
			//登录账号是否存在
			var validateUserName = (rule, value, callback) => {
				if (this.existenceUserName) { //不通过
					callback(new Error('该登录账号已存在,请重新输入！'))
				} else { //通过
					callback()
				}
			}
			return {
				//员工工号是否存在
				existenceJobNumber: false,
				//员工登录账号是否存在
				existenceUserName: false,
				//顶部搜索 员工状态：0未知 1在职（默认） 2离职 3删除
				SearchFlag: 1,
				//员工工号 （点击解锁时获取）
				jobNumber: '',
				//员工列表
				staffList: [
					// AlmaMater: ""
					// Companies: Array(0)
					// CreateTime: "2021-07-26T16:08:11.117"
					// CurrentResidence: ""
					// Degree: ""
					// Flag: 1
					// IDNumber: ""
					// JobNumber: "00001"
					// JoinTime: null
					// Name: "1"
					// NativePlace: ""
					// Password: "1"
					// PasswordErrorCount: 0
					// Phone: ""
					// QuitTime: null
					// Sex: 0
					// Specialty: ""
					// UserName: "1"
				],
				//是否显示弹出框 修改 单个添加 批量添加
				dialogFormVisibleUpdate: false,
				dialogFormVisibleAdd: false,
				formLabelWidth: '100px',
				//更新单条员工信息
				staffInfo: {
					Flag: 1, // 1在职  2离职  3删除
					IDNumber: '1', //身份证号
					JobNumber: '00003', //工号
					Name: '1', //员工姓名
					Password: '1', //密码
					PasswordErrorCount: 1, //密码输入次数
					Sex: 1, // 0未知  1男  2女
					UserName: '1', //用户名
					Phone: '', //联系电话
					NativePlace: '', //籍贯
					CurrentResidence: '', //现居住地
					AlmaMater: '', //毕业院校
					Degree: '', //学历
					Specialty: '', //专业
					JoinTime: null, //入职时间
					QuitTime: null, //离职时间 （状态为离职时，显示此项）
				},
				//添加单个员工
				addInfo: {
					Flag: 1, // 1在职  2离职  3删除
					IDNumber: '', //身份证号
					JobNumber: '', //工号
					Name: '', //员工姓名
					Password: '', //密码
					Sex: 1, // 0未知  1男  2女
					UserName: '', //用户名
					Phone: '', //联系电话
					NativePlace: '', //籍贯
					CurrentResidence: '', //现居住地
					AlmaMater: '', //毕业院校
					Degree: '', //学历
					Specialty: '', //专业
					JoinTime: null, //入职时间
					QuitTime: null, //离职时间 （状态为离职时，显示此项）
				},
				//表单验证规则 添加
				AddRules: {
					JobNumber: [{
							required: true,
							message: '请输入员工工号',
							trigger: 'blur'
						},
						{
							validator: validateJobNumber,
							trigger: 'blur'
						}
					],
					UserName: [{
						validator: validateUserName,
						trigger: 'blur'
					}]
				},
				// 角色列表
				roles:[],
				value1: [],
				// 密码加密公钥
				key:""
			}
		},
		mounted() {
			//查询员工列表
			this.getStaffList()
			// 查询所有角色
			this.getAllRole()
			// 获取加密公钥（设置密码时使用
			this.getRSAPublicKey()
		},
		methods: {
			// 获取rsa加密公钥
			async getRSAPublicKey(){
				try{
					let res = await this.$http.getRSAPublicKey()
					this.key = res.data.base64
					console.log(res);
				}catch(e){
					this.$message.error(`获取加密公钥失败，请重试${e}`)
				}
			},
			// 删除员工权限
			async delRole(e,row){
				console.log(e,row);
				var data = {
					jobNumber: row.JobNumber,
					roleId: e
				}
				let res = await this.$http.delEmplooyeeRole(data)
				var ind = row.TBEmployeeRoles.findIndex(v=>v.RoleId==e)
				row.TBEmployeeRoles.splice(ind,1)
				
			},
			// 查询所有角色
			getAllRole() {
				this.$http.getAllRole().then(res => {
					if (res.status == 200) {
						this.roles = res.data
					}
				})
			},
			// 设置员工角色
			async setRole(row){
				console.log(row);
				var itemRoles = row.TBEmployeeRoles;
				var roles = row.roles;
				roles.map(async v=>{
					var fig = itemRoles.some(e=>e.RoleId==v)
					if(!fig){
						var data = {
							jobNumber: row.JobNumber,
							roleId: v
						}
						let res = await this.$http.setEmployeeRole(data)
						itemRoles.push(data)
					}
				})
				// console.log(row);
				
				// console.log(res);
				// let val =  await this.$http.getEmplooyeeRole(row.JobNumber)
				// console.log(val);
			},
			// 更新、添加 改变员工状态事件
			changeFlag(flag) {
				// console.log("当前员工状态为：" + flag)
				if (flag == 1) { //状态为在职  则清空离职时间
					if (this.dialogFormVisibleUpdate) { //修改
						this.staffInfo.QuitTime = null
					} else if (this.dialogFormVisibleAdd) { //添加
						this.addInfo.QuitTime = null
					}
				}
			},
			// 弹窗关闭时重置表单
			onCloseAdd() {
				this.$refs['addInfo'].resetFields()
			},
			//查询员工列表
			getStaffList(SearchFlag) {
				var flag = this.SearchFlag //flag：0未知 1在职 2离职（默认查询在职）3删除
				if (flag == 1) { //在职 1
					let status = '?flag=1'
					var jiekou = this.$http.getStaffList(status)
				} else if (flag == 2) { // 离职 2
					let status = '?flag=2'
					var jiekou = this.$http.getStaffList(status)
				} else { // 全部(不传参数)
					let status = ''
					var jiekou = this.$http.getStaffList(status)
				}
				jiekou.then(res => {
					// console.log(res.data)
					if (res.data.length > 0) {
						this.staffList = res.data.map(v=>{
							v.roles = v.TBEmployeeRoles.map(e=>e.RoleId)
							return v
						})
					} else {
						this.staffList = []
					}
				})
			},
			//跳转批量添加员工页面
			toAddbatch() {
				this.$router.push({
					path: '/system/batchadd'
				})
			},
			//添加员工
			submitAdd(addInfo) {
				// console.log(this.addInfo)
				//表单验证
				this.$refs[addInfo].validate((valid) => {
					if (valid) { //验证成功 返回 true 提交数据
						let data = this.addInfo
						data.Password = rsa.setRsa(this.key,data.Password)
						this.$http.addStaffInfo(data).then(res => {
							// console.log(res)
							if (res.data.Code == 200) {
								this.$message.success({
									message: '添加成功！'
								})
								//关闭弹框
								this.dialogFormVisibleAdd = false
								//查询员工列表
								this.getStaffList() //或者 页面刷新 this.reload()
							} else {
								this.$message.success({
									message: '添加员工失败！'
								})
							}
						})
					} else { //验证失败
						return false;
					}
				});
			},
			//更新员工信息并提交
			submitUpdate(staffInfo) {
				//提交更改的数据
				// console.log(this.staffInfo)
				let data = this.staffInfo
				data.Password = rsa.setRsa(this.key,data.Password)
				this.$http.updateStaffInfo(data).then(res => {
					// console.log(res.data)
					if (res.data.Code == 200) {
						//关闭弹框
						this.dialogFormVisibleUpdate = false
						this.$message.success({
							message: '修改成功！'
						})
						//查询员工列表
						this.getStaffList() //或者 页面刷新 this.reload()
					} else {
						this.$message.error({
							message: '修改失败！'
						})
					}
				})
			},
			//更改员工信息
			handleAuditStaff(index, row) {
				// console.log(index)
				// console.log(row)
				this.jobNumber = row.JobNumber
				// console.log('员工工号: ' + this.jobNumber)
				this.staffInfo = this.staffList[index]
				//弹出修改框
				this.dialogFormVisibleUpdate = true
			},
			//员工密码解锁
			handleUnlockingStaff(index, row) {
				// console.log(row)
				this.jobNumber = row.JobNumber
				// console.log('操作人工号: ' + this.UserData.JobNumber)
				// console.log('被解锁员工工号: ' + this.jobNumber)
				// 拼接参数： jobNumber 操作人工号 、unlockJobNumber 被解锁员工工号
				let staffId = '?jobNumber=' + this.UserData.JobNumber + '&&unlockJobNumber=' + this.jobNumber
				this.$http.UnlockPassword(staffId).then(res => {
					// console.log(res.data)
					if (res.data.Code == 200) { //解锁成功
						this.$message.success({
							message: '解锁成功！'
						})
						this.getStaffList()
					}
				})
			},
			//判断员工工号是否存在
			judgeStaffJobNumber() {
				// console.log(this.addInfo.JobNumber)
				if (this.addInfo.JobNumber != '') {
					let jobNumber = '?jobNumber=' + this.addInfo.JobNumber
					this.$http.judgeStaffJobNumber(jobNumber).then(res => {
						// console.log(res.data)
						this.existenceJobNumber = res.data
					})
				}
			},
			//判断登录账号是否存在
			judgeStaffUserName() {
				if (this.addInfo.UserName != '') {
					// 特殊字符编码
					var userName = encodeURIComponent(this.addInfo.UserName)
					// console.log(userName)
					let UserName = '?userName=' + userName
					this.$http.judgeStaffUserName(UserName).then(res => {
						// console.log(res.data)
						this.existenceUserName = res.data
					})
				}
			},
			// //查询单个员工信息
			// getSingleStaffInfo(){
			//   let jobNum = '?jobNumber=' + this.jobNumber
			//   this.$http.getSingleStaffInfo(jobNum).then(res=>{
			//     console.log(res)
			//     if(res.data != null){  //查询到数据
			//       //弹出框 展示员工信息
			//       this.dialogFormVisibleUpdate = true
			//       this.staffInfo = res.data
			//       console.log(this.staffInfo)
			//     }else{
			//       // 未查询到该员工信息
			//       console.log("未查询到该员工信息")
			//     }
			//   })
			// }
		}
	}
</script>

<style>
	.pagesContent {
		width: 100%;
		height: 100%;
	}

	.main-box {
		background-color: #FFFFFF;
	}

	.header-title {
		height: 36px;
		line-height: 36px;
	}

	/* 对话框 */
	.dialog-body {
		/* width: 100%; */
		/* height: 65vh; */
		/* box-sizing: border-box; */
		padding: 0 40px 0 100px;
	}
</style>
